import LIcon from 'src/assets/icons/projects/l-icon.svg'
import AiCidIcon from 'src/assets/icons/projects/ai-cid-icon.svg'
import SprintInteractionIcon from 'src/assets/icons/projects/sprint-interaction-icon.svg'
import ProgrammingIcon from 'src/assets/icons/projects/programming-icon.svg'
import KanBanIcon from 'src/assets/icons/projects/kanban-icon.svg'

import jsIcon from 'src/assets/icons/projects/js-icon.svg'
import qtIcon from 'src/assets/icons/projects/qt-icon.svg'
import pythonIcon from 'src/assets/icons/projects/python-icon.svg'
import cPlusIcon from 'src/assets/icons/projects/cplus-icon.svg'
import reactIcon from 'src/assets/icons/projects/react-icon.svg'
import flutterIcon from 'src/assets/icons/projects/flutter-icon.svg'

export const PROJECTS_LIST = [
  {
    src: LIcon,
    category: 'LENOVO',
    text: 'Lenovo Diagnostics for Smart Collaboration'
  },
  {
    src: LIcon,
    category: 'LENOVO',
    text: 'Lenovo Diagnostics Evolution'
  },
  {
    src: LIcon,
    category: 'LENOVO',
    text: 'Lenovo Diagnostics for ARM'
  },
  {
    src: AiCidIcon,
    category: 'LENOVO',
    text: 'Customer Induced Damage Detection Evolution'
  }
]

export const METHODOLOGY_USED_LIST = [
  {
    src: SprintInteractionIcon,
    text: 'Scrum'
  },
  {
    src: ProgrammingIcon,
    text: 'Extreme Programming (XP)'
  },
  {
    src: KanBanIcon,
    text: 'Kanban'
  }
]

export const TECHNOLOGIES_USED_LIST = [
  {
    src: jsIcon,
    text: 'JavaScript'
  },
  {
    src: qtIcon,
    text: 'QT'
  },
  {
    src: pythonIcon,
    text: 'Python'
  },
  {
    src: cPlusIcon,
    text: 'C++'
  },
  {
    src: reactIcon,
    text: 'React'
  },
  {
    src: flutterIcon,
    text: 'Flutter'
  }
]
